import React from "react";
import { Box, Typography } from "@mui/material";
import FilterDropdown from "./FilterDropdown";
import useFilterSelections from "./useFilterSelections";

interface FilterOption {
  id: string;
  label: string;
}

interface FilterOptions {
  yearOptions: FilterOption[];
  monthOptions: FilterOption[];
  mrNameOptions: FilterOption[];
}

interface SummaryFilterCardProps {
  filterOptions: FilterOptions;
}

const SummaryFilterCard: React.FC<SummaryFilterCardProps> = ({ filterOptions }) => {
  const {
    selectedYearIds,
    selectedMonthIds,
    selectedMrIds,
    handleYearFilterChange,
    handleMonthFilterChange,
    handleMrFilterChange,
    error,
  } = useFilterSelections({
    filterOptions,
    endpoint: "MyPerformance/MyPerformanceSummary",
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: "0",
        padding: "16px 0",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flex: "1" }}>
        <FilterDropdown
          items={filterOptions.mrNameOptions}
          onFilterChange={handleMrFilterChange}
          placeholder="Select items..."
          FiterLabel="MR Name"
          active={true}
          initialSelectedIds={selectedMrIds}
        />
        <FilterDropdown
          items={filterOptions.yearOptions}
          onFilterChange={handleYearFilterChange}
          placeholder="Select items..."
          FiterLabel="Year"
          active={true}
          initialSelectedIds={selectedYearIds}
        />
        <FilterDropdown
          items={filterOptions.monthOptions}
          onFilterChange={handleMonthFilterChange}
          placeholder="Select items..."
          FiterLabel="Month"
          active={true}
          initialSelectedIds={selectedMonthIds}
        />
      </Box>

      {error && (
        <Typography color="error" sx={{ mt: 1 }}>
          Error: {error}
        </Typography>
      )}
    </Box>
  );
};

export default SummaryFilterCard;